import { ReactComponent as LineHeightIcon } from 'assets/icons/line_height.svg';
import { SliderPopover } from 'modules/common/components/ToolbarPopover';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuProps } from './TextToolbar.types';

const MIN_LINE_HEIGHT = 0.8;
const MAX_LINE_HEIGHT = 3.0;

interface LineHeightProps {
  minLineHeight?: number;
  maxLineHeight?: number;
}

export const LineHeight = memo(({ onChange, value, minLineHeight, maxLineHeight }: MenuProps & LineHeightProps) => {
  const { t } = useTranslation('editor_toolbar', { useSuspense: false, keyPrefix: 'lineHeight' });
  const handleChangeHeight = (newValue: number) => onChange(newValue.toString());
  const label = t('label');

  return (
    <SliderPopover
      value={Number(value)}
      icon={<LineHeightIcon />}
      label={label}
      onChange={handleChangeHeight}
      min={minLineHeight || MIN_LINE_HEIGHT}
      max={maxLineHeight || MAX_LINE_HEIGHT}
      step={0.1}
      title={label}
      iconVariant={'icon-btn-toolbar'}
    />
  );
});

LineHeight.displayName = 'LineHeight';
